<p-toast position="bottom-center" [preventOpenDuplicates]="true"></p-toast>
<div>
  <div class="app-container">
    <app-navbar></app-navbar>
    @if (this.signalService.isLoading$()) {
      <app-loading-modal></app-loading-modal>
      }
    <app-main></app-main>
  </div>
</div>